import React, { useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import PostForm from './PostForm';
import PostList from './PostList';
import ChannelList from './ChannelList';
import NotificationBadge from './NotificationBadge';
import './Dashboard.css';

const Dashboard = ({ user }) => {
  const [selectedChannel, setSelectedChannel] = useState(null);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleChannelSelect = (channel) => {
    setSelectedChannel(channel);
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <h1 className="dashboard-title">Building HFJ</h1>
          <div className="user-info">
            <NotificationBadge 
              currentUser={user} 
              onNavigateToPost={handleChannelSelect}
              selectedChannel={selectedChannel}
            />
            <span className="user-email">{user.email}</span>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </div>
        </div>
      </header>
      
      <main className="dashboard-main">
        <aside className="channels-sidebar">
          <ChannelList 
            currentUser={user}
            selectedChannel={selectedChannel}
            onChannelSelect={handleChannelSelect}
          />
        </aside>
        
        <div className="posts-section">
          {selectedChannel && (
            <div className="channel-header">
              <h2>#{selectedChannel.name}</h2>
              {selectedChannel.description && (
                <p className="channel-description">{selectedChannel.description}</p>
              )}
            </div>
          )}
          <PostForm user={user} selectedChannel={selectedChannel} />
          <PostList currentUser={user} selectedChannel={selectedChannel} />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;